<script>
import { defineComponent } from '@vue/composition-api';
import { useBrand } from '@/use/brand';
import { useRouter } from '@/use/router';
import logo from '@/components/logo.vue';
import { ROUTE_PAY } from '@/lib/router';

export default defineComponent({
  name: 'SomethingWentWrong',
  components: { logo },
  props: {
    artifactDetails: {
      type: Object,
      required: false,
    },
    errorMessage: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const brand = useBrand();
    const router = useRouter();
    function redirectBack() {
      router.push({ name: ROUTE_PAY, params: { artifactId: props.artifactDetails.artifactId } });
    }
    return {
      brand,
      router,
      redirectBack,
    };
  },
});
</script>

<template>
  <div class="flex flex-col items-center justify-center px-2">
    <div class="w-full max-w-screen-lg pt-4">
      <logo size="small" class="" />
    </div>
    <div class="mt-20 max-w-screen-sm">
      <h1 class="heading-2 md:heading-1 text-center mb-8">Something seems to have gone wrong</h1>
      <p class="text-shades-dark">{{errorMessage }}</p>
      <p class="text-shades-dark mt-4">
        Please try again or contact the {{ brand.name }}
      Support Team at <a class="cursor-pointer text-primary-dark" :href="`mailto:${brand.contactEmail}`">
      {{ brand.contactEmail }}</a> or call us at <span class="cursor-pointer text-primary-dark">
      {{ brand.contactPhone }}</span>.
      </p>
      <div v-if="artifactDetails" class="my-4 text-shades-dark">
        <p>
          For questions about payment options and your legal bill, please contact
          <span class="font-bold">{{ artifactDetails.partyName }}</span> at:
        </p>
        <div class="text-center mt-8 mb-10">
          <h3 class="font-bold">{{ artifactDetails.partyName }}</h3>
          <p>{{ artifactDetails.contactNumber }}</p>
          <p>{{ artifactDetails.contactEmail }}</p>
        </div>
        <a @click="redirectBack" class="cursor-pointer text-primary-dark underline text-center">
          <p>Back to Payment methods</p>
        </a>
      </div>
    </div>
  </div>
</template>

<style scoped>
</style>
